/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SysqueDropdownConnectorsComponent } from './sysque-dropdown-connectors.component';
import { SysqueSelectBoxModule } from '../sysque-select-box';

@NgModule({
  declarations: [SysqueDropdownConnectorsComponent],
  imports: [CommonModule, SysqueSelectBoxModule],
  exports: [SysqueDropdownConnectorsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SysqueDropdownConnectorsModule {}
